<template>
    <div id="menu-main" data-menu-active="nav-homes" style="width:280px;" class="offcanvas offcanvas-start offcanvas-detached rounded-m">
        <div class="card card-style bg-23 mb-3 rounded-m mt-3" data-card-height="150">
            <div class="card-top m-3">
                <a href="#" data-bs-dismiss="offcanvas" class="icon icon-xs bg-theme rounded-s color-theme float-end"><i class="bi bi-caret-left-fill"></i></a>
            </div>
            <div class="card-bottom p-3">
                <h1 class="color-white font-20 font-700 mb-n2">Quran</h1>
                <p class="color-white font-12 opacity-70 mb-n1">Quran Mobile</p>
            </div>
            <div class="card-overlay bg-gradient-fade rounded-0"></div>
        </div>

        <div class="bg-theme mx-3 rounded-m shadow-m mt-3 mb-3">
            <div class="d-flex px-2 pb-2 pt-2">
                <div>
                    <a href="#"><img :src="this.userProfile.image" width="45" class="rounded-s" alt="img"></a>
                </div>
                <div class="ps-2 align-self-center">
                    <h5 class="ps-1 mb-0 line-height-xs pt-1">{{ this.userProfile.name }}</h5>
                    <h6 class="ps-1 mb-0 font-400 opacity-40">{{ this.userProfile.email }}</h6>
                </div>
                <div class="ms-auto">
                    <a href="#" data-bs-toggle="dropdown" class="icon icon-m ps-3"><i class="bi bi-three-dots-vertical font-18 color-theme"></i></a>
                    <div class="dropdown-menu  bg-transparent border-0 mt-n1 ms-3">
                        <div class="card card-style rounded-m shadow-xl mt-1 me-1">
                            <div class="list-group list-custom list-group-s list-group-flush rounded-xs px-3 py-1">
                                <a href="page-profile-admin.html" class="color-theme opacity-70 list-group-item py-1"><strong class="font-500 font-12">Your Profile</strong><i class="bi bi-chevron-right"></i></a>
                                <a href="page-activity.html" class="color-theme opacity-70 list-group-item py-1"><strong class="font-500 font-12">Notifications</strong><i class="bi bi-chevron-right"></i></a>
                                <a href="page-login-2.html" class="color-theme opacity-70 list-group-item py-1"><strong class="font-500 font-12">Log Out</strong><i class="bi bi-chevron-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body progress-card">
                <ProgressLearn/>
            </div>
        </div>

        <div class="p-3">
            <router-link :to="{ name: 'quran.index' }" class="btn btn-full btn-outline-primary mb-2">
                <i class="bi bi-book"></i>
                Baca Alquran
            </router-link>
            <router-link :to="{ name: 'quran.index' }" class="btn btn-full btn-outline-primary mb-2">
                <i class="bi bi-play-circle-fill"></i>
                Melanjutkan Baca
            </router-link>
            <router-link :to="{ name: 'learnQuran' }" class="btn btn-full btn-outline-primary mb-2">
                <i class="bi bi-stack-overflow"></i>
                Belajar Quran
            </router-link>
            <router-link :to="{ name: 'quran.index' }" class="btn btn-full btn-outline-primary mb-2">
                <i class="bi bi-search"></i>
                Pencarian Kata
            </router-link>
        </div>

        <p class="text-center mt-3 mb-0 pb-3 font-9 text-uppercase font-600 color-theme">Made with <i class=" font-9 px-1 bi bi-heart-fill color-red-dark"></i> by Digital Solusindo <span class="copyright-year"></span>.</p>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ProgressLearn from './ProgressLearn.vue';

export default {
    name: 'Sidebar',
    components: {
        ProgressLearn,
    },
    computed: {
        ...mapState({
            userProfile: state => state.userProfile
        })
    },
}
</script>

<style scoped>
.btn.btn-full.btn-outline-primary.mb-2 {
    color: #0d6efd;
}
.progress-card {
    background-color: #6558f5;
}
.progress-card h3 {
    color: #f7c325;
}
</style>